import React, { useState } from 'react';
import { Container, Row, Col, Card, CardBody } from "react-bootstrap";

export default function Dashboard() {
  const [showConfirm, setShowConfirm] = useState(false);

  return (<div className="dashboard-page">
          <Container fluid>
            <div className='page-title-main'>
              <h5 className='page-title'>Petrol Bunk - Dashboard</h5>
              <p className='page-info'>Manage petrol bunk details, cameras, and assigned admins.</p>
            </div> 
            <div className='page-content-main'>
              
            </div>   
          </Container>
        </div>);
}
